import { useTasksStore } from '../stores/tasks.store'
import { dbgEvent } from '../lib/debug'

/**
 * Handler de l'ensemble des taches background vivantes (reconception du suivi, operation #31513).
 *
 * Derive de routeTerminal() sur le modele EXACT de tasksHandler : le canal terminal:{sid} porte un
 * 3e nom d'event, 'background_tasks' (les deux autres : 'terminal' → terminalHandler, 'task_progress'
 * → tasksHandler). routeTerminal distingue par le NOM d'event ; cet event ne va NULLE PART ailleurs —
 * surtout PAS dans liveEvents (regime B ephemere, sans seq : jamais persiste, jamais confirme, donc
 * jamais elague — c'est la condition qui rend le regime sur, cf. brief §4bis etage 5).
 *
 * Semantique REPLACE : l'event porte l'ENSEMBLE COMPLET des sous-agents background vivants. On en
 * derive la liste des task_id vivants et on la donne a `reconcile`, qui marque terminal/perdu tout
 * task_id de la session ABSENT de cet ensemble et pas deja terminal. C'est le remplacement du timeout
 * de silence : la vivacite se lit de cet event d'autorite, jamais d'un delai.
 *
 * Ce handler n'ecrit QUE le tasks.store, jamais le terminal.store.
 */

// Charge utile diffusee par le serveur pour l'event 'background_tasks' (envelope { event, data }).
// Miroir de BackgroundTasksPayload cote serveur, + eventId ajoute a la diffusion. Champs SDK a
// l'identique. Type local (le client n'importe pas les types serveur/protocole a l'execution).
interface BackgroundTasksData {
  type?: string
  sessionId?: string
  tasks?: { task_id: string; task_type?: string; description?: string }[]
  [key: string]: unknown
}

export const backgroundTasksHandler = {
  onBackgroundTasks(sessionId: string, data: BackgroundTasksData): void {
    const tasks = data.tasks ?? []
    dbgEvent('Zustand', 'tasks.onBackgroundTasks', { sessionId: sessionId.slice(0, 8), count: tasks.length })
    useTasksStore.getState().reconcile(
      sessionId,
      tasks.map((t) => t.task_id),
    )
  },
}
